import React from 'react';
import {
    Card,
    Legend,
    LegendOrientations,
    Text,
} from '@clockout-dev/design-elements';
import PeriodToggle from './PeriodToggle';
import CashflowBars from './CashflowBars';
import { CASHFLOW_GROUPING, CASHFLOW_SERIES } from '../treasury.constants';
import styles from './styles/cashflowChartCard.module.scss';

/**
 * "Cashflow Over Time" card. Pure presentational shell that wires up
 * the toggle, the bar chart, and the legend.
 *
 * Receives `data = { monthly: [...], quarterly: [...] }` and the
 * current `grouping` + `onGroupingChange`. Picks the right series for
 * the active grouping at render time. Bars and legend stay in sync via
 * `CASHFLOW_SERIES` — same array drives both.
 */
function CashflowChartCard({ data, grouping = CASHFLOW_GROUPING.MONTHLY, onGroupingChange }) {
    const rows = data?.[grouping] ?? [];

    return (
        <Card className={styles.card}>
            <header className={styles.header}>
                <div className={styles.titleBlock}>
                    <Text as="h3" size="l" className={styles.title}>Cashflow Over Time</Text>
                    <Text as="p" size="xs" className={styles.subtitle}>Institutional Inflows vs Operational Outflows</Text>
                </div>
                <PeriodToggle value={grouping} onChange={onGroupingChange} />
            </header>

            <div className={styles.chartArea}>
                <CashflowBars rows={rows} height={280} />
            </div>

            <Legend
                items={CASHFLOW_SERIES.map(({ label, color }) => ({ label, color }))}
                orientation={LegendOrientations.HORIZONTAL}
                className={styles.legendRow}
                classes={{
                    dot: styles.legendDot,
                    text: styles.legendText,
                }}
            />
        </Card>
    );
}

export default CashflowChartCard;
